module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAA3NCSVQICAjb4U/gAAAABmJLR0QAAgCIANGdcUBlAAABMElEQVRYhWNk6rjIMJgA00A7AB2MOogQGHUQITDqIEJg1EGEwKiDCIFRBxECow4iBAadg1jI06YkwDbDQ4aBgSFk/QM+NuYaa3EPRV5hTuYnn39vuP2p7djLz7/+0dVBvGxMzvI8DAwMrgq8091lhDmZIeJqQuxl5qIeirxWi29///OfDJMpjbIF3rLHnn61XnxHfNJVkwW319z8yMDAoCfGkWssQp6BlDpo693PAWsfnHj27c33v+dffo/Y8PDmu58MDAy+qvwD46Dl194jc/8zMBx89JWBgUFVkG1gHIQJPvz8y8DAwMvGTJ526jvo////DAwMjIxkah905dCogwiBUQcRAqMOIgQYR4djCIBRBxECow4iBEYdRAiMOogQGHUQITDqIEJg1EGEwKBzEAALQ0RGRsrM9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/picture5.jpg
// module id = 371
// module chunks = 0